var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-container"},[_c('el-upload',{staticStyle:{"font-size":"0"},attrs:{"action":"","http-request":_vm.chooseFile,"show-file-list":false,"before-upload":_vm.beforeFileUpload}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }